/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipConsentChannelBlock } from './HomeownershipConsentChannelBlock';
import {
    HomeownershipConsentChannelBlockFromJSON,
    HomeownershipConsentChannelBlockFromJSONTyped,
    HomeownershipConsentChannelBlockToJSON,
} from './HomeownershipConsentChannelBlock';
import type { HomeownershipContactPrefill } from './HomeownershipContactPrefill';
import {
    HomeownershipContactPrefillFromJSON,
    HomeownershipContactPrefillFromJSONTyped,
    HomeownershipContactPrefillToJSON,
} from './HomeownershipContactPrefill';
import type { HomeownershipHomeBlock } from './HomeownershipHomeBlock';
import {
    HomeownershipHomeBlockFromJSON,
    HomeownershipHomeBlockFromJSONTyped,
    HomeownershipHomeBlockToJSON,
} from './HomeownershipHomeBlock';
import type { HomeownershipLastLookBlock } from './HomeownershipLastLookBlock';
import {
    HomeownershipLastLookBlockFromJSON,
    HomeownershipLastLookBlockFromJSONTyped,
    HomeownershipLastLookBlockToJSON,
} from './HomeownershipLastLookBlock';
import type { HomeownershipLockBlock } from './HomeownershipLockBlock';
import {
    HomeownershipLockBlockFromJSON,
    HomeownershipLockBlockFromJSONTyped,
    HomeownershipLockBlockToJSON,
} from './HomeownershipLockBlock';
import type { HomeownershipLoiBlock } from './HomeownershipLoiBlock';
import {
    HomeownershipLoiBlockFromJSON,
    HomeownershipLoiBlockFromJSONTyped,
    HomeownershipLoiBlockToJSON,
} from './HomeownershipLoiBlock';
import type { HomeownershipPageState } from './HomeownershipPageState';
import {
    HomeownershipPageStateFromJSON,
    HomeownershipPageStateFromJSONTyped,
    HomeownershipPageStateToJSON,
} from './HomeownershipPageState';
import type { HomeownershipSaleBlock } from './HomeownershipSaleBlock';
import {
    HomeownershipSaleBlockFromJSON,
    HomeownershipSaleBlockFromJSONTyped,
    HomeownershipSaleBlockToJSON,
} from './HomeownershipSaleBlock';
import type { HomeownershipTermsBlock } from './HomeownershipTermsBlock';
import {
    HomeownershipTermsBlockFromJSON,
    HomeownershipTermsBlockFromJSONTyped,
    HomeownershipTermsBlockToJSON,
} from './HomeownershipTermsBlock';

/**
 * 
 * @export
 * @interface HomeownershipPageResponse
 */
export interface HomeownershipPageResponse {
    /**
     * 
     * @type {HomeownershipPageState}
     * @memberof HomeownershipPageResponse
     */
    state: HomeownershipPageState;
    /**
     * 
     * @type {HomeownershipHomeBlock}
     * @memberof HomeownershipPageResponse
     */
    home: HomeownershipHomeBlock;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipPageResponse
     */
    contactOnFile: boolean;
    /**
     * 
     * @type {HomeownershipContactPrefill}
     * @memberof HomeownershipPageResponse
     */
    contactPrefill?: HomeownershipContactPrefill;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipPageResponse
     */
    residentFirstName?: string;
    /**
     * 
     * @type {Array<HomeownershipConsentChannelBlock>}
     * @memberof HomeownershipPageResponse
     */
    consentChannels?: Array<HomeownershipConsentChannelBlock>;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipPageResponse
     */
    canChangeMind?: boolean;
    /**
     * 
     * @type {HomeownershipSaleBlock}
     * @memberof HomeownershipPageResponse
     */
    sale?: HomeownershipSaleBlock;
    /**
     * 
     * @type {HomeownershipTermsBlock}
     * @memberof HomeownershipPageResponse
     */
    terms?: HomeownershipTermsBlock;
    /**
     * 
     * @type {HomeownershipLockBlock}
     * @memberof HomeownershipPageResponse
     */
    lock?: HomeownershipLockBlock;
    /**
     * 
     * @type {HomeownershipLoiBlock}
     * @memberof HomeownershipPageResponse
     */
    loi?: HomeownershipLoiBlock;
    /**
     * 
     * @type {HomeownershipLastLookBlock}
     * @memberof HomeownershipPageResponse
     */
    lastLook?: HomeownershipLastLookBlock;
}

/**
 * Check if a given object implements the HomeownershipPageResponse interface.
 */
export function instanceOfHomeownershipPageResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "home" in value;
    isInstance = isInstance && "contactOnFile" in value;

    return isInstance;
}

export function HomeownershipPageResponseFromJSON(json: any): HomeownershipPageResponse {
    return HomeownershipPageResponseFromJSONTyped(json, false);
}

export function HomeownershipPageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipPageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'state': HomeownershipPageStateFromJSON(json['state']),
        'home': HomeownershipHomeBlockFromJSON(json['home']),
        'contactOnFile': json['contact_on_file'],
        'contactPrefill': !exists(json, 'contact_prefill') ? undefined : HomeownershipContactPrefillFromJSON(json['contact_prefill']),
        'residentFirstName': !exists(json, 'resident_first_name') ? undefined : json['resident_first_name'],
        'consentChannels': !exists(json, 'consent_channels') ? undefined : ((json['consent_channels'] as Array<any>).map(HomeownershipConsentChannelBlockFromJSON)),
        'canChangeMind': !exists(json, 'can_change_mind') ? undefined : json['can_change_mind'],
        'sale': !exists(json, 'sale') ? undefined : HomeownershipSaleBlockFromJSON(json['sale']),
        'terms': !exists(json, 'terms') ? undefined : HomeownershipTermsBlockFromJSON(json['terms']),
        'lock': !exists(json, 'lock') ? undefined : HomeownershipLockBlockFromJSON(json['lock']),
        'loi': !exists(json, 'loi') ? undefined : HomeownershipLoiBlockFromJSON(json['loi']),
        'lastLook': !exists(json, 'last_look') ? undefined : HomeownershipLastLookBlockFromJSON(json['last_look']),
    };
}

export function HomeownershipPageResponseToJSON(value?: HomeownershipPageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'state': HomeownershipPageStateToJSON(value.state),
        'home': HomeownershipHomeBlockToJSON(value.home),
        'contact_on_file': value.contactOnFile,
        'contact_prefill': HomeownershipContactPrefillToJSON(value.contactPrefill),
        'resident_first_name': value.residentFirstName,
        'consent_channels': value.consentChannels === undefined ? undefined : ((value.consentChannels as Array<any>).map(HomeownershipConsentChannelBlockToJSON)),
        'can_change_mind': value.canChangeMind,
        'sale': HomeownershipSaleBlockToJSON(value.sale),
        'terms': HomeownershipTermsBlockToJSON(value.terms),
        'lock': HomeownershipLockBlockToJSON(value.lock),
        'loi': HomeownershipLoiBlockToJSON(value.loi),
        'last_look': HomeownershipLastLookBlockToJSON(value.lastLook),
    };
}

